export const SessionTimeout = 'atlantis-session-timeout';
